import config from '@/config';
import cookies from 'vue-cookies';
import service from '@/api-service';

export default {
    state: {
        memberInfo: {},
        hasGetMemberInfo: false,
        loginPhone: cookies.get(config.const.KEY_LOGIN_PHONE),
        verifyTime: cookies.get(config.const.KEY_VERIFY_TIME),
        authCode: cookies.get(config.const.KEY_AUTH_CODE),
        openId: cookies.get(config.const.KEY_WX_OPEN_ID),
    },

    getters: {
        authCode(state) {
            return state.authCode && state.authCode.length > 12 ? state.authCode : void(0);
        },
        loginPhone(state) {
            return state.loginPhone || void(0);
        },
        verifyTime(state) {
            return state.verifyTime || void(0);
        },
        openId(state) {
            return state.openId || void(0);
        },
        hasGetMemberInfo(state) {
            return state.hasGetMemberInfo;
        }
    },

    mutations: {
        setMemberInfo(state, memberInfo) {
            state.memberInfo = memberInfo;
        },
        setVerifyTime(state, dateTime) {
            state.verifyTime = dateTime;
            dateTime ? cookies.set(config.const.KEY_VERIFY_TIME, dateTime, new Date(dateTime)) : cookies.remove(config.const.KEY_VERIFY_TIME);
        },
        setLoginPhone(state, loginPhone) {
            state.loginPhone = loginPhone;
            loginPhone === false ? cookies.remove(config.const.KEY_LOGIN_PHONE) : cookies.set(config.const.KEY_LOGIN_PHONE, loginPhone, '7D');
        },
        setAuthCode(state, authCode) {
            state.authCode = authCode;
            authCode === false ? cookies.remove(config.const.KEY_AUTH_CODE) : cookies.set(config.const.KEY_AUTH_CODE, authCode, '7D');
        },
        setOpenId(state, openId) {
            state.openId = openId;
            openId === false ? cookies.remove(config.const.KEY_WX_OPEN_ID) : cookies.set(config.const.KEY_WX_OPEN_ID, openId, '7D');
        }
    },

    actions: {
        logout({ state, commit }) {
            return new Promise((resolve, reject) => {
                commit('setMemberInfo', {});
                commit('setAuthCode', false);
                commit('setLoginPhone', false);
                commit('setOpenId', false);
                state.hasGetMemberInfo = false;
                resolve();
            })
        },

        getMemberInfo({ state, commit }) {
            return new Promise((resolve, reject) => {
                service.getMemberInfo().then((res) => {
                    commit('setMemberInfo', {
                        nickName: res.member.nickname,
                        avatar: res.member.headimgurl,
                        mobile: res.member.mobile
                    });
                    state.hasGetMemberInfo = true;
                    resolve();
                })
            })
        }
    }
};